import './App.css';
import { Route, Routes } from 'react-router-dom'

import Home from './pages/Home';
import AboutUs from './pages/AboutUs';
import ContactUs from './pages/ContactUs';
import OurEvents from './pages/OurEvents';
import Timeline from './pages/Timeline';
import JoinUs from './pages/JoinUs';
import JoinSuccess from './pages/JoinSuccess';
import ForgotPassword from './pages/ForgotPassword';
import PrivacyPolicy from './components/PrivacyPolicy';
import AdminPanel from './components/AdminPanel';
import AdminLogin from './pages/AdminLogin';
import SuperAdminPanel from './pages/SuperAdminPanel'; 

function App() {
  return (
    <div>

      
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/AboutUs" element={<AboutUs />} />
        <Route path="/ContactUs" element={<ContactUs />} />
        <Route path="/Events" element={<OurEvents />} />
        <Route path="/Timeline" element={<Timeline />} />
        <Route path="/JoinUs" element={<JoinUs />} />
        <Route path="/JoinSuccess" element={<JoinSuccess />} />
        <Route path="/ForgotPassword" element={<ForgotPassword />} />
        <Route path="/PrivacyPolicy" element={<PrivacyPolicy />} />
        <Route path="/OurEvents" element={<OurEvents />} />
        <Route path="/admin-panel" element={<AdminPanel />} />
        <Route path="/admin-login" element={<AdminLogin />} />
        <Route path="/super-admin-panel" element={<SuperAdminPanel />} />
      </Routes>
    </div>
  );
}

export default App;